import { AfterViewInit, Component, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ApiGoal, ApiMilestone } from '@tytapp/api';

@Component({
    selector: 'tyt-goal-progress',
    templateUrl: './goal-progress.component.html',
    styleUrls: ['./goal-progress.component.scss']
})
export class GoalProgressComponent implements AfterViewInit {

    private _goal: ApiGoal;

    @Input() unit: string;

    @Input()
    set goal(value: ApiGoal) {
        this._goal = value;
    }

    get goal(): ApiGoal {
        return this._goal;
    }

    currentValuePercentage: number;

    private _currentValue: number;

    @Input()
    set currentValue(value: number) {
        this._currentValue = value;

        setTimeout(() => {
            this.currentValuePercentage = Math.min(100, Math.round(this._currentValue * 100 / this.goal.number));
            if (this.currentValueBar) {
                this.currentValueBar.style.width = `${this.currentValuePercentage}%`;
            }
        });
    }

    get currentValue(): number {
        return this._currentValue;
    }

    private _mode: "bar" | "milestones" | "both" = "both";

    @Input()
    set mode(value: "bar" | "milestones" | "both") {
        this._mode = value;
    }

    get mode() {
        return this._mode;
    }

    element: HTMLElement;
    currentValueBar: HTMLElement;

    goalCompletedImagePath = './assets/petitions/goal-completed.svg';
    goalPendingImagePath = './assets/petitions/goal-pending.svg';

    constructor(
        private elementRef: ElementRef
    ) { }

    ngAfterViewInit() {
        this.element = this.elementRef.nativeElement;
        this.currentValueBar = this.element.querySelector('.current-bar');
    }

}
